import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs5 from "./page_us/solution-US-5/Section-Us-5.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
    
useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Façade Textile Maroc | Architecture Moderne & Design – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Façades textiles au Maroc avec UNIK SYSTEM : habillage architectural extérieur, structures modernes et design haut de gamme pour hôtels, centres commerciaux et projets d’envergure."
  );

  setMeta(
    "keywords",
    "facade textile maroc, habillage facade maroc, facade moderne maroc, architecture facade maroc, structure textile facade maroc, facade exterieur design maroc, UNIK SYSTEM facade"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/façade-bioclimatique-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Façade Textile Maroc – Design & Architecture | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Habillage de façade moderne avec structures textiles pour projets architecturaux haut de gamme."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/32Fa%C3%A7ade%20architecturale%20%C3%A9quip%C3%A9e%20d%E2%80%99%C3%A9crans%20solaires%20textiles%20pour%20protection%20thermique%20et%20design%20contemporain_imgupscaler..f7a0ed30d6a8a6e00312.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/façade-bioclimatique-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Façade Textile Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Architecture de façade design et moderne avec structures textiles."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/32Fa%C3%A7ade%20architecturale%20%C3%A9quip%C3%A9e%20d%E2%80%99%C3%A9crans%20solaires%20textiles%20pour%20protection%20thermique%20et%20design%20contemporain_imgupscaler..f7a0ed30d6a8a6e00312.webp"
  );

  // ========= SCHEMA (ARCHITECTURE SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en façades textiles et habillage architectural moderne au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Façades & Architecture",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Façade Textile Design"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Habillage Architectural Extérieur"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-facade");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-facade";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi une façade textile ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est une structure extérieure en textile technique utilisée pour habiller et protéger un bâtiment."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Design moderne, protection thermique, légèreté et esthétique architecturale."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels projets ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Hôtels, centres commerciaux, bâtiments professionnels et projets architecturaux haut de gamme."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-facade");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-facade";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);



  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs5/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;